import React, { useState, useEffect } from 'react'
import { Box, Select, NumberInput, Flex, Group, Button, Text } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError, loadingNotification, completedLoadingNotification } from '../../../../ui/Notifications'
import { calculation } from '../../../../../services/calculation'
import { validation } from '../../../../../plugins/validation'
import { shipmentMethodType } from '../../../../../helper/master-unit'

const defaultVal = {
  shipment_method: '',
  logistic_per_unit: null
}

const formValidation = {
  shipment_method: {
    isError: false,
    message: ''
  },
  logistic_per_unit: {
    isError: false,
    message: ''
  },
}


const FormAdjustShipmentMethod = ({ dataShipment, onCloseForm }) => {
  const { summary } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitShipmentMethod = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    const validateForm = {
      shipment_method: form.shipment_method,
      logistic_per_unit: `${form.logistic_per_unit}`
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    try {
      const response = await updateOrder(orderId, form)
      if (response.success) {
        notificationSuccess('Update Order Successfully', 'This data has been updated')
        const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
        const responseCalculation = await calculation(orderId)
        if (responseCalculation.success) {
          onCloseForm()
          dispatch(getOrderDetail(orderId))
          completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
        }
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (dataShipment) {
      handleSetForm(dataShipment)
    }
    // eslint-disable-next-line
  }, [dataShipment])

  const handleSetForm = (value) => {
    const dataDetail = {
      shipment_method: value.shipmentMethod,
      logistic_per_unit: value.logisticPerUnit
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  return (
    <Box>
      <Box mb='md'>
        <Select
          name='shipment_method'
          value={formData.shipment_method}
          label='Shipment Method'
          placeholder='Select Shipment Method'
          data={shipmentMethodType}
          onChange={(val) => handleChangeForm('shipment_method', val)}
          error={validationForm.shipment_method.isError ? `${validationForm.shipment_method.message}` : ''}
          size='xs'
          allowDeselect={false}
          withAsterisk
        />
      </Box>
      <Box mb='md'>
        <NumberInput
          name='logistic_per_unit'
          label="Logistic Cost"
          value={formData.logistic_per_unit}
          leftSection={<Text fz='xs' c='black' tt='capitalize'>{summary.orderCurrency}</Text>}
          placeholder='Input logistic cost'
          onChange={(val) => handleChangeForm('logistic_per_unit', val)}
          error={validationForm.logistic_per_unit.isError ? `${validationForm.logistic_per_unit.message}` : ''}
          size='xs'
          withAsterisk
          thousandSeparator=","
          leftSectionWidth={40}
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitShipmentMethod(formData)}>Update</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustShipmentMethod